import { styled } from '@mui/material/styles';

export const StyledCancelReasonContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledCancelReasonItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  height: 32px;
  justify-content: start;
`;
